













import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../../main";
import NoteAziende from "@/components/NoteAziende.vue";

@Component({
    components: {
        NoteAziende
    }
})
export default class NoteAziendeDialog extends Vue {
    @Prop() idAzienda!: any;
    @Prop() nomeAzienda!: any;  

    private dialog: boolean;
    private noteAziendaDataTableParams: any;

    constructor() {
        super();
        this.dialog = false;
        this.noteAziendaDataTableParams = {
            headers: [
                {
                    text: "Nota",
                    value: "nota"
                },
                {
                    text: "Utente",
                    value: "utenteNotaAzienda"
                },
                {
                    text: "Data Nota",
                    value: "dataCreazione"
                },
                {
                    text: "Dettagli Nota",
                    value: "detailsNotaAzienda"
                },
                {
                    text: "Modifica",
                    value: "editNotaAzienda"
                },
                {
                    text: "Cancella",
                    value: "deleteNotaAzienda"
                }
            ],
            records: [],
            detailsDialogParams: {
                title: "DETTAGLI NOTA AZIENDA",
                type: "notaAzienda"
            }
        };
    }

    close() {
        this.dialog = false;
        bus.$emit("destroyNoteAziendeDialog");
    }
}
